import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { NgxMdService } from 'ngx-md';

@Component({
	selector: 'spaq-markdown',
	template: ` <ngx-md [data]="text"></ngx-md> `,
	styles: [
		`
			ngx-md {
				height: 600px;
				overflow: auto;
				border: 1px solid rgba(0, 0, 0, 0.1);
				background-color: #dedede;
				padding: 1rem;
				white-space: normal;
				max-width: 100%;
				display: block;
			}
		`
	],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class MarkdownComponent implements OnInit {
	@Input() text = '';

	constructor(private markdownService: NgxMdService) {}

	ngOnInit(): void {
		this.markdownService.renderer.link = (link: string) => {
			return `<a href="${link}" target="_blank">${link}</a>`;
		};
	}
}
